angular
  .module("digitalLeasing.module")
  .component("albaFooter", {
    templateUrl: "ng/components/digitalLeasing/footer/footer.view.html",
    bindings: {
      nextStepVisible: "<",
      backStepVisible: "<",
      pauseVisible: "<",
      nextStepEnabled: "<",
      backStepEnabled: "<",
      pauseEnabled: "<",
      titleNextStep: "<",
      titleBackStep: "<",
      navigationBack: "&",
      navigationNext: "&",
      navigationPause: "&",
      titleNext: "@",
      titleBack: "@",
      loaderBack: '<',
      loaderNext: '<',
      loaderSuspend: '<',
      enablePulse: '<',
      enableSuspend: '<',
      isPostVendita: '<'
    },
    controllerAs: "albaFooterCtrl",
    controller: function (
      $modalService,
      $portalService,
      $rootScope
    ) {
      var self = this;
      self.$modalService = $modalService;

      self.$onInit = function () {
        self.$portalService = $portalService;
      };

      self.$onChanges = function (changes) {
        if (changes.loaderBack) {
          self.navigator.loading.back = changes.loaderBack.currentValue;
          if (changes.loaderBack.currentValue && self.isPostVendita) {
            $rootScope.$broadcast("pageLoader", {
              action: "OPEN"
            });
          } else {
            $rootScope.$broadcast("pageLoader", {
              action: "CLOSE"
            });
          }
        }
        if (changes.loaderNext) {
          self.navigator.loading.next = changes.loaderNext.currentValue;
          if (changes.loaderNext.currentValue && self.isPostVendita) {
            $rootScope.$broadcast("pageLoader", {
              action: "OPEN"
            });
          } else {
            $rootScope.$broadcast("pageLoader", {
              action: "CLOSE"
            });
          }
        }
        if (changes.loaderSuspend) {
          self.navigator.loading.pause = changes.loaderSuspend.currentValue;
          if (changes.loaderSuspend.currentValue && self.isPostVendita) {
            $rootScope.$broadcast("pageLoader", {
              action: "OPEN"
            });
          } else {
            $rootScope.$broadcast("pageLoader", {
              action: "CLOSE"
            });
          }
        }
      }

      self.navigator = {
        loading: {
          next: false,
          back: false,
          pause: false
        },
        somethingLoading: function () {
          var some = false;
          Object.keys(this.loading).forEach(function (value) {
            if (self.navigator.loading[value] == true) {
              some = true;
            }
          });
          return some;
        },
        nextStep: function () {
          this.loading.next = true;
          self.navigationNext();
          this.loading.next = false;
        },
        backStep: function () {

          this.loading.back = true;
          self.navigationBack();
          this.loading.back = false;
        },
        suspend: function () {
          if (self.enableSuspend) {
            self.navigationPause();
          } else {
            $modalService.openModal('suspendInstance')
          }
        }
      };

      self.nextStepIsEnabled = function () {
        return self.nextStepEnabled
      }
    }
  });